function initScienceExpertsFlip(section) {
  section.querySelectorAll('[data-expert-flip]').forEach((card) => {
    const toggle = card.querySelector('[data-expert-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const isFlipped = card.classList.toggle('is-flipped');
      toggle.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');

      const label = isFlipped ? toggle.getAttribute('data-label-less') : toggle.getAttribute('data-label-more');
      if (label) toggle.setAttribute('aria-label', label);
    });
  });
}

function initScienceExperts() {
  document.querySelectorAll('.section-science-experts').forEach((section) => {
    initScienceExpertsFlip(section);
  });
}

document.readyState !== 'loading' ? initScienceExperts() : document.addEventListener('DOMContentLoaded', initScienceExperts);
